<template>
<b-row>
  <b-col cols="1"><span class="text-danger" style="font-size: 50px; font-weight: 700;">3</span></b-col>
  <b-col md="11" lg="6" class="pt-3">
    <b-btn block href="#" v-b-toggle.stack-accordion-03 variant="outline-danger" class="text-danger rounded-0 py-0" style="font-size: 24px; font-weight: 700">
      <b-row align-v="center" >
        <div class="bg-danger" style="height: 50px; width: 50px;">
          <div class="pt-1"><img src="/images/trinity_icon_red_with_outline.png" height="30"></div>
        </div>
        <div style="text-align: left">
          Trinity AI
          <font-awesome-icon :icon="iconCaretDown" size="1" />
        </div>
      </b-row>
    </b-btn>
  </b-col>
  <b-row>
    <b-col cols="11" offset="1">
      <b-collapse id="stack-accordion-03" accordion="stack-accordion" class="px-3">
        <p>Trinity is able to conceptually 'understand' linked data and transform it into linked actionable information.</p>
        <b-row class="py-2">
          <b-col>
            <h2 style="color: #2e145e;">Trinity Inferred Forms</h2>
          </b-col>
        </b-row>
        <b-row class="pb-4">
          <b-col md="12" lg="8">
            <img src="/images/trinity_inferred.png" class="img-fluid">
          </b-col>
          <b-col md="12" lg="4">
            <p>Trinity understands your information conceptually and can automatically generate forms with all of the relevant properties with picklists for entering information.</p>
          </b-col>
        </b-row>
        <b-row class="py-2">
          <b-col>
            <h2 style="color: #2e145e;">Trinity Conceptual Linking</h2>
            <p>Trinity can take your data and conceptually link it for you. Rather than a traditional text search, when using the graphMetrix Pod service,  Trinity enables conceptual semantic search.</p>
          </b-col>
        </b-row>
        <!-- images lg version -->
        <b-row align-v="center">
          <b-col cols="5" class="d-none d-lg-block py-2">
            <img src="/images/trinity_conceptual_link.png" class="img-fluid">
          </b-col>
          <b-col cols="1" style="text-align: center" class="d-none d-lg-block px-0">
            <span style="color: #ff0000;">
              <font-awesome-icon :icon="iconArrowRight" size="3x"/>
            </span>
          </b-col>
          <b-col cols="6" class="d-none d-lg-block">
            <span><img src="/images/bim_doors_selected.png" class="img-fluid"></span>
          </b-col>
        </b-row>
        <!-- images md version -->
        <b-row align-v="center" class="d-lg-none py-2">
          <b-col cols="12">
            <img src="/images/trinity_conceptual_link.png" class="img-fluid">
          </b-col>
          <b-col cols="12" style="text-align: center" class="">
            <span style="color: #ff0000;">
              <font-awesome-icon :icon="iconArrowDown" size="3x"/>
            </span>
          </b-col>
          <b-col cols="12">
            <span><img src="/images/bim_doors_selected.png" class="img-fluid"></span>
          </b-col>
        </b-row>
        <b-row class="py-2">
          <b-col>
            <h2 style="color: #2e145e;">Trinity PDF</h2>
            <p>Trinity isolates each logical grouping of text on the sheet/page and transforms it into a Solid text object with a unique URL including the hierarchical relationships to other objects. Additionally, Trinity captures the location of each text and image grouping on the sheet allowing her to infer sheet information such as sheet number, title, scale, date, etc. and automatically create sheet set linking.</p>
            <b-row align-h="center" class="pb-2">
              <b-btn class="btn mx-3 my-2 pr-3 pl-1 py-0" :to="{name: 'pdfGraphing'}" target="_blank" variant="outline-secondary" style="color: #2e145e !important">
                <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="1 1 37 37">
                  <g id="Trinity_Button" data-name="Trinity Button" transform="translate(-1600 -180)">
                    <g id="Group_Trinity_button">
                      <path fill="#F9F9F9" stroke="#2E145E" stroke-width="0.7794" stroke-miterlimit="10" d="M1629.7,200.3c0,6.4-7,12.7-9.8,12.7
                        c-2.9,0-9.8-6.3-9.8-12.7s4.4-11.6,9.8-11.6S1629.7,193.9,1629.7,200.3z"/>
                      <path fill="#2E145E" stroke="#FFFFFF" stroke-width="3.120000e-02" stroke-miterlimit="10" d="M1619.3,202.6
                        c-0.3,1.4-2.1,2.6-4.5,2.1c-2.4-0.5-3.4-1.7-4-3.4c-0.2-1.5-0.4-2.6,4.9-1.8C1618.1,199.9,1619.5,201.2,1619.3,202.6z"/>
                      <path fill="#F9F9F9" d="M1623.1,186.8c0,0,0.1,0,0.1,0s0.2,3.4-0.4,4.3c-0.2,0-0.3-0.1-0.3-0.1S1622.6,188.9,1623.1,186.8z"/>
                      <path fill="#2E145E" stroke="#FFFFFF" stroke-width="3.120000e-02" stroke-miterlimit="10" d="M1620.7,202.6
                        c0.3,1.4,2.1,2.6,4.5,2.1c2.4-0.5,3.4-1.7,4-3.4c0.2-1.5,0.4-2.6-4.9-1.8C1621.8,199.9,1620.4,201.2,1620.7,202.6z"/>
                      <path fill="#2E145E" d="M1622.4,191.1c0,0-1.6,1-2.8,1.2c-5.2,0.9-8.1,6.1-9.3,8.5c-0.1,0.3-0.6-1.3-0.6-1.5c0,0-2-15,13.3-12.4
                        C1623.2,188.6,1622.4,191.1,1622.4,191.1z"/>
                      <path fill="#2E145E" d="M1622.8,191.1c0,0,2.3,0.7,3.5,1.9c1.6,1.5,3,3.6,3.2,7.9c2.6-6.8-1.2-13.1-6.3-14
                        C1623.3,188.3,1623,190.4,1622.8,191.1z"/>
                      <path fill="none" stroke="#2E145E" stroke-width="0.3117" stroke-miterlimit="10" d="M1618.5,201c0,0,1.5,0.5,2.9,0"/>
                      <path fill="#FFFFFF" d="M1620.6,193.7c0.3,1.1,0.1,2.4-2.3,2.8c-1.9-0.1-3.5-0.4-3.7-0.9c0.8-1.1,1.3-1.7,2.8-2.2
                        C1619.1,192.8,1619.5,192.3,1620.6,193.7z"/>
                      <path fill="#FFFFFF" d="M1613.9,199.6c0,0-1.9-0.2-2.5,0.2c-0.5,0.4-0.3,1.1-0.3,1.1S1611.7,199.9,1613.9,199.6z"/>
                      <path fill="#2E145E" d="M1610.8,203.8c0,0,0.8,2.4-0.6,4.6s4,0.9,4,0.9L1610.8,203.8z"/>
                      <path fill="#2E145E" d="M1629.1,203.8c0,0-0.8,2.4,0.6,4.6s-4,0.9-4,0.9L1629.1,203.8z"/>
                      <path fill="#FFFFFF" d="M1624.1,199.9c-0.8,0-1.9,0.5-2.4,1.1c-0.4,0.4-0.5,0.7-0.4,1C1621.9,201.1,1623.6,200.1,1624.1,199.9z"/>
                      <path fill="#666699" d="M1614.3,194.6c0,0,1.1-1.6,4.7-2.7c-0.8,0.1-1.3,0.2-2.8,0.9C1615,193.3,1614.3,194.6,1614.3,194.6z"/>
                      <path fill="#666699" d="M1614.1,194c0,0,1.1-1.5,4.4-2.4c-0.8,0.1-1.2,0.1-2.6,0.7C1614.9,192.7,1614.1,194,1614.1,194z"/>
                      <path fill="#666699" d="M1614,193.4c0,0,1.1-1.5,4.2-2.3c-0.7,0.1-1.1,0.1-2.4,0.6C1614.8,192.1,1614,193.4,1614,193.4z"/>
                      <path fill="#666699" d="M1613.7,192.7c0,0,1.1-1.5,4.3-2.2c-0.7,0.1-1.1,0-2.4,0.6C1614.5,191.5,1613.7,192.7,1613.7,192.7z"/>
                      <path fill="#666699" d="M1613.3,192c0,0,1-1.3,4.3-2.3c-0.8,0.1-1.2,0.1-2.6,0.8C1614,190.9,1613.3,192,1613.3,192z"/>
                      <path fill="#666699" d="M1613.1,191.3c0,0,0.9-1.3,4-2.3c-0.7,0.1-1.1,0.1-2.4,0.7C1613.8,190.3,1613.1,191.3,1613.1,191.3z"/>
                      <path fill="#666699" d="M1612.8,190.7c0,0,0.9-1.3,3.8-2.2c-0.7,0.1-1,0.1-2.2,0.7C1613.5,189.6,1612.8,190.7,1612.8,190.7z"/>
                      <path fill="#666699" d="M1612.6,190c0,0,0.9-1.3,3.7-2.3c-0.7,0.1-1,0.1-2.2,0.7C1613.2,188.9,1612.6,190,1612.6,190z"/>
                    </g>
                  </g>
                </svg>
                Read more
              </b-btn>
            </b-row>
            <b-row>
              <b-col>
                <img src="/images/pdf_parsing.png" class="img-fluid">
              </b-col>
            </b-row>
            <!--b-row class="py-3">
              <b-col>
                <b-embed class="embed-responsive" aspect="16by9" src="https://www.youtube.com/embed/TgN3cisaw-8"></b-embed>
              </b-col>
            </b-row-->
          </b-col>
        </b-row>
      </b-collapse>
    </b-col>
  </b-row>
</b-row>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowRight, faArrowDown, faCaretDown } from '@fortawesome/free-solid-svg-icons'
export default {
  name: 'stack03',
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
    iconArrowRight: faArrowRight,
    iconArrowDown: faArrowDown,
    iconCaretDown: faCaretDown,
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.text-danger:hover {
  color: #f8f9fa !important;
}
</style>
